import { MailOutline, PhoneOutlined } from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { IconBox } from "../contactUs";
import logoSmall from "../../../images/png/logo_small.png";
import { theme } from "../../../utilities/themes";

const ContactUsDialog = ({ open, setOpen }) => {
  const handleClose = () => {
    setOpen(false);
  };
  const spanFontSizes1 = {
    fontSize: { lg: "1.125rem", md: "1rem", sm: "0.875rem", xs: "0.875rem" },
  };
  const spanFontSizes2 = {
    fontSize: { lg: "1rem", md: "0.875rem", sm: "0.75rem", xs: "0.75rem" },
  };
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Stack direction="row" minHeight="4vh" spacing={1} alignItems="center">
          <Box sx={{ width: "40px" }}>
            <img src={logoSmall} alt="logo" style={{ width: "100%" }} />
          </Box>
          <Typography variant="h5" color={theme.palette.primary.main}>
            CONTACT US
          </Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} pt={3} pb={3} sx={{ width: "70%" }}>
          <Stack direction={"row"} alignItems="center" spacing={2}>
            <IconBox>
              <MailOutline fontSize="small" htmlColor="white" />
            </IconBox>
            <Stack>
              <Typography component={"span"} sx={{ ...spanFontSizes1 }}>
                Email:
              </Typography>
              <Typography
                component={"span"}
                sx={{ ...spanFontSizes2 }}
                fontWeight={300}
              >
                <a
                  href="mailto:customer-support@little.africa"
                  style={{
                    color: theme.palette.primary.main,
                    textDecoration: "none",
                  }}
                >
                  customer-support@little.africa
                </a>
              </Typography>
            </Stack>
          </Stack>
          <Stack direction={"row"} alignItems="center" spacing={2}>
            <IconBox>
              <PhoneOutlined fontSize="small" htmlColor="white" />
            </IconBox>
            <Stack>
              <Typography component={"span"} sx={{ ...spanFontSizes1 }}>
                Tel:
              </Typography>
              <Typography
                component={"span"}
                sx={{ ...spanFontSizes2 }}
                fontWeight={300}
              >
                <a
                  href="tel:customer-support@little.africa"
                  style={{
                    color: theme.palette.primary.main,
                    textDecoration: "none",
                  }}
                >
                  0113138966
                </a>
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};
export default ContactUsDialog;
